<template>
  <button
      :type="type ? type : ''"
      class="button"
      :disabled="isDisabled"
      :class="[{active: isLoading}]"
  >
    <ui-loader class="button__loader" v-if="isLoading" />
    <slot v-else />
  </button>
</template>

<script setup>
import UiLoader from "@/components/ui/ui-loader.vue";

const props = defineProps({
  isDisabled: Boolean,
  isLoading: Boolean,
  type: String
})
</script>

<style lang="scss" scoped>
.button {
  color: #3B3B3B;
  font-size: 21px;
  font-weight: 400;

  border: 1px solid #DD6196;
  padding: 13px 20px;
  border-radius: 27px;
  transition: 0.3s;

  cursor: pointer;

  display: flex;
  align-items: center;
  justify-content: center;
  gap: 7px;

  &:hover {
    box-shadow: 0 0 5px 1px #DD6196;
  }

  &:disabled {
    cursor: not-allowed;
    background-color: #efefef;
  }

  &:disabled:hover, &.active {
    background-color: #efefef;
    box-shadow: unset;
  }

  & a, p, span{
    white-space: nowrap;
    display: flex;
    align-items: center;
  }

  &__loader {
    margin-block: 7px;
  }
}

@media (max-width: 500px) {
  .button {
    font-size: 18px;
  }
}
</style>